import React from 'react';
import { BusinessInfoCollectionStepper } from '@fiverr-private/business_blocks';
import SafePureComponent from '../shared/SafePureComponent';

export const BusinessCollectionStepper = () => (
    <BusinessInfoCollectionStepper source={BusinessInfoCollectionStepper.Consumers.GIG_PAGE} />
);

export default SafePureComponent(BusinessCollectionStepper);
